/**
 * Module dependencies.
 */

import { AdvisorMarketType } from 'src/types/markets';
import { ChemicalType, Refill } from 'src/types/model-ranges';
import { CylinderType } from 'src/types/technologies';
import {
  acceptLanguageHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Query` type.
 */

type Query = {
  formData: {
    company: string;
    country: string;
    email: string;
    message?: string | null;
    n_of_ballons?: number;
    name: string;
    phone?: string | null;
    position?: string | null;
    recaptcha_token: string;
    refillable?: Refill;
    subscribe_to_newsletter: boolean;
    type_gas?: AdvisorMarketType;
    type_of_chemical?: ChemicalType;
    type_of_cylinder?: CylinderType;
    water_capacity?: number;
  };
  locale: string;
};

/**
 * Export `submitAdvisorForm`.
 */

export async function submitAdvisorForm({ formData, locale }: Query) {
  const endpoint = getApiEndpoint('advisorForm');

  try {
    await request.post(endpoint, formData, {
      headers: acceptLanguageHeader(locale)
    });
  } catch (error) {
    throw handleRequestError(error);
  }
}
